export const initialUserData = {
  id: 1,
  name: 'Dante Moss',
  email: 'dante@cafemoctezuma.com',
  phone: '+541234567890',
  password: 'Dantetiana',
  avatar: '👤',
  token: 'fake-jwt-token-dante-12345',
  joinedDate: '2024-01-15'
};

export const initialRecentOrders = [
  {
    id: 180,
    items: [
      {
        id: 3,
        name: 'Cappuccino',
        description: 'Espresso with foamed milk',
        price: 4.50,
        finalPrice: 4.50,
        size: 'Grande',
        sweetness: 'Normal',
        takeaway: true,
        quantity: 1,
        total: 4.50,
        category: 'coffee'
      }
    ],
    store: {
      id: 1,
      name: 'Monserrat',
      address: 'Av Boedo 1356 (Boedo, CABA)',
      hours: 'lunes a viernes 8 am - 22 PM',
      distance: '500 m away'
    },
    subtotal: 4.50,
    tip: 0.68,
    total: 5.18,
    status: 'completed',
    paymentMethod: 'card',
    timestamp: '2024-11-27T14:30:00Z',
    user: 'Dante Moss'
  },
  {
    id: 179,
    items: [
      {
        id: 5,
        name: 'Moka',
        description: 'Rich chocolate coffee',
        price: 5.25,
        finalPrice: 7.88,
        size: 'Big',
        sweetness: 'More',
        takeaway: false,
        quantity: 1,
        total: 7.88,
        category: 'coffee'
      },
      {
        id: 15,
        name: 'Brownies',
        description: 'Chocolate brownie',
        price: 3.50,
        finalPrice: 3.50,
        size: 'Small',
        sweetness: 'Normal',
        takeaway: false,
        quantity: 2,
        total: 7.00,
        category: 'bakery'
      }
    ],
    store: null,
    subtotal: 14.88,
    tip: 2.23,
    total: 17.11,
    status: 'completed',
    paymentMethod: 'card',
    timestamp: '2024-11-26T10:15:00Z',
    user: 'Dante Moss'
  },
  {
    id: 178,
    items: [
      {
        id: 10,
        name: 'Strawberry',
        description: 'Sweet strawberry smoothie',
        price: 7.75,
        finalPrice: 11.63,
        size: 'Big',
        sweetness: 'Normal',
        takeaway: true,
        quantity: 1,
        total: 11.63,
        category: 'smoothies'
      }
    ],
    store: {
      id: 2,
      name: 'Caballito',
      address: 'Av Rivadavia 2381 (Caballito, CABA)',
      hours: 'lunes a viernes 8 am - 22 PM\nsabado 9 AM - 21 PM',
      distance: '1.2 km away'
    },
    subtotal: 11.63,
    tip: 1.74,
    total: 13.37,
    status: 'completed',
    paymentMethod: 'digital',
    timestamp: '2024-11-25T16:45:00Z',
    user: 'Dante Moss'
  }
];

export const initialSavedCards = [
  {
    id: 1,
    type: 'visa',
    number: '**** 1234',
    lastFour: '1234',
    name: 'DANTE MOSS',
    expiry: '12/25',
    bank: 'Chase Bank',
    isDefault: true
  },
  {
    id: 2,
    type: 'mastercard',
    number: '**** 5678',
    lastFour: '5678',
    name: 'DANTE MOSS',
    expiry: '08/24',
    bank: 'Bank of America',
    isDefault: false
  }
];

export const initialStores = [
  {
    id: 1,
    name: 'Monserrat',
    address: 'Av Boedo 1356 (Boedo, CABA)',
    hours: 'lunes a viernes 8 am - 22 PM',
    distance: '500 m away',
    likes: 245
  },
  {
    id: 2,
    name: 'Caballito',
    address: 'Av Rivadavia 2381 (Caballito, CABA)',
    hours: 'lunes a viernes 8 am - 22 PM\nsabado 9 AM - 21 PM',
    distance: '1.2 km away',
    likes: 189
  },
  {
    id: 3,
    name: 'Villa Crespo',
    address: 'Habana 954 (Crespo, CABA)',
    hours: 'lunes a viernes 7 AM - 23 PM\nsabado 8 AM - 1 AM\ndomingo 8 AM - 22 PM',
    distance: '2.5 km away',
    likes: 312
  },
  {
    id: 4,
    name: 'Palermo',
    address: 'Serrano 1382 (Palermo, CABA)',
    hours: 'lunes a viernes 9 AM - 00 AM\nsabado 8 AM - 1 AM\ndomingo 8 AM - 22 PM',
    distance: '3.0 km away',
    likes: 156
  }
];